"use client";

import { c as _c } from "react/compiler-runtime";
import { Translation } from "@/components/Translation/Translation.component";
import { useImpression } from "@/vendors/Kilkaya/hooks/impression/use-impression.hook";
import { impressionTags } from "@/vendors/Kilkaya/kilkaya.types";
export function NameMissingPrompt() {
  const $ = _c(4);
  useImpression(impressionTags.commentNameMissing);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p><Translation da="Du er logget ind, men vi har problemer med at hente dit navn." de="Sie sind eingeloggt, aber wir haben Probleme, Ihren Namen abzurufen." en="You are logged in, but we're having trouble retrieving your name." no={"Du er logget inn, men vi har problemer med \xE5 hente navnet ditt."} sv={"Du \xE4r inloggad, men vi har problem med att h\xE4mta ditt namn."} /></p>;
    t1 = <p><Translation da="Log ud, og log ind igen for at kunne kommentere." de={"Melden Sie sich ab und erneut an, um kommentieren zu k\xF6nnen."} en="Log out and log in again to comment." no={"Logg ut og logg inn igjen for \xE5 kommentere."} sv={"Logga ut och logga in igen f\xF6r att kommentera."} /></p>;
    t2 = <Translation da={"Har du aldrig knyttet et navn til dit login, skal du g\xF8re det"} de={"Wenn Sie noch keinen Namen mit Ihrem Login verkn\xFCpft haben, tun Sie dies"} en="If you have never linked a name to your login, you can do so" no={"Hvis du aldri har knyttet et navn til innloggingen din, m\xE5 du gj\xF8re det"} sv={"Om du aldrig har kopplat ett namn till din inloggning kan du g\xF6ra det"} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-silent py-4 text-left font-medium text-dim text-sm md:py-2">{t0}{t1}<p>{t2}{" "}<a className="text-primary underline" href="https://medielogin.dk/mit/medielogin" rel="noopener noreferrer" target="_blank"><Translation da="her" de="hier" en="here" no="her" sv={"h\xE4r"} /></a>.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}